import type { ReactElement } from 'react';
import { ResponsiveContainer } from 'recharts';

interface ChartContainerProps {
  children: ReactElement;
  height?: number;
}

export function ChartContainer({
  children,
  height = 300,
}: ChartContainerProps) {
  return (
    <div data-testid="chart-container">
      <ResponsiveContainer width="100%" height={height}>
        {children}
      </ResponsiveContainer>
    </div>
  );
}
